export default class BackofficeMenusForm {
  constructor() {
    this.bindEvents();
  }

  bindEvents() {
    // Toggle dropdown fields visibility based on is_dropdown checkbox
    $('#is_dropdown').on('change', (e) => this.toggleDropdownFields(e));
    
    // Toggle parent/dropdown based on parent selection
    $('#parent-select').on('change', (e) => this.toggleParentFields(e));
    
    // Icon preview on input
    $('.icon-input').on('input', (e) => this.updateIconPreview(e));
    
    // Auto-generate identifier from name if empty
    $('input[name="menu_item[name]"]').on('blur', (e) => this.suggestIdentifier(e));
  }

  toggleDropdownFields(e) {
    const isDropdown = $(e.target).is(':checked');
    const collapseGroup = $('.collapse-group');
    
    if (isDropdown) {
      collapseGroup.slideDown();
    } else {
      collapseGroup.slideUp();
    }
  }

  toggleParentFields(e) {
    const hasParent = $(e.target).val() !== '';
    const dropdownGroup = $('.dropdown-group');
    const collapseGroup = $('.collapse-group');
    
    if (hasParent) {
      // If has parent, hide dropdown option
      dropdownGroup.slideUp();
      collapseGroup.slideUp();
      $('#is_dropdown').prop('checked', false);
    } else {
      dropdownGroup.slideDown();
      // Show collapse fields if dropdown is checked
      if ($('#is_dropdown').is(':checked')) {
        collapseGroup.slideDown();
      }
    }
  }

  updateIconPreview(e) {
    const iconClass = $(e.target).val() || 'fas fa-question';
    $('.icon-preview i').attr('class', iconClass);
  }

  suggestIdentifier(e) {
    const nameInput = $(e.target);
    const identifierInput = $('input[name="menu_item[identifier]"]');
    
    // Only suggest if identifier is empty
    if (identifierInput.val().trim() !== '') {
      return;
    }
    
    const name = nameInput.val();
    
    // If name looks like an i18n key, extract the last part
    let suggested = name;
    if (name.includes('.')) {
      const parts = name.split('.');
      suggested = parts[parts.length - 1];
    }
    
    // Convert to snake_case identifier
    suggested = suggested
      .toLowerCase()
      .replaceAll(/[àáâãäå]/g, 'a')
      .replaceAll(/[èéêë]/g, 'e')
      .replaceAll(/[ìíîï]/g, 'i')
      .replaceAll(/[òóôõö]/g, 'o')
      .replaceAll(/[ùúûü]/g, 'u')
      .replaceAll(/[ç]/g, 'c')
      .replaceAll(/[^a-z0-9]/g, '_')
      .replaceAll(/_+/g, '_')
      .replaceAll(/(?:^_)|(?:_$)/g, '');
    
    identifierInput.val(suggested);
  }

  onDataChanged(data) {
  }

  onDestroy() {
  }
}
